module.exports = __webpack_public_path__ + "img/r02.70c493a4.png";